angular.module('app').factory('AttachmentsService', function () {
    // Process new attachments and expose Notes, Receipts, Logs
    let fac = {
        processAttachments: processAttachments
    };
    return fac;
    function processAttachments(dto, renderedAttachments, selectedItems) {
        // We don't need to make a timestamp adjustment as we display relative time
        // Get the attachments for this Test
        let attachments = _.filter(dto.Attachments, function (att) {
            return (att.UserId === selectedItems.selectedTester.Id &&
                att.ProjectIterationId === selectedItems.projectIterationId &&
                att.SimId === selectedItems.selectedSim.Id &&
                att.SuiteId === selectedItems.selectedSuite.Id &&
                att.TestId === selectedItems.selectedTest.Id);
        });
        // If we filtered down to nothing then just return
        if (attachments.length === 0) {
            let combinedAttachments;
            return combinedAttachments;
        }
        // Union the existing attachments
        let existingAttachments = _.union(renderedAttachments.Receipts, renderedAttachments.Logs, renderedAttachments.Notes);
        // Dedup the new attachements
        let nonDuplicateAttachments = removeDuplicateNewRows(attachments, existingAttachments);
        // Split them up into receipts, logs, and notes again
        let newReceipts = _.filter(nonDuplicateAttachments, function (x) {
            return x.AttachmentType === 'receipt';
        });
        let newLogs = _.filter(nonDuplicateAttachments, function (x) {
            return x.AttachmentType === 'log';
        });
        let newNotes = _.filter(nonDuplicateAttachments, function (x) {
            return x.AttachmentType === 'note';
        });
        let combinedAttachments = {};
        // Merge the new attachments with the existing attachments
        let allReceipts = _.union(renderedAttachments.Receipts, newReceipts);
        combinedAttachments.Receipts = sortByReverseTimestamp(allReceipts);
        let allLogs = _.union(renderedAttachments.Logs, newLogs);
        combinedAttachments.Logs = sortByReverseTimestamp(allLogs);
        let allNotes = _.union(renderedAttachments.Notes, newNotes);
        combinedAttachments.Notes = sortByReverseTimestamp(allNotes);
        return combinedAttachments;
    }
    function removeDuplicateNewRows(newRows, existingRows) {
        let existingRowIds = _.map(existingRows, 'Id');
        let nonDuplicateNewRows = _.reject(newRows, function (newRow) {
            return _.includes(existingRowIds, newRow.Id);
        });
        return nonDuplicateNewRows;
    }
    function sortByReverseTimestamp(lst) {
        let ascending = _.sortBy(lst, function (x) {
            return x.Timestamp;
        });
        return ascending.reverse();
    }
});
